import Hls from "hls.js";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import ChatComponent from "../components/Chat";
import Sidebar from "../components/Slidebar";

export default function Live() {
  const { matchId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLive, setDataLive] = useState({});
  const [listLive, setListLive] = useState();
  const [paging, setPaging] = useState({ current: 1, pageSize: 9 });
  const [isShowLoadMore, setIsShowLoadMore] = useState(false);
  const videoRef = useRef(null);
  const videoQc = useRef(null);
  useEffect(() => {
    fetchData();
  }, [matchId]);

  useEffect(() => {
    listDataLive();
    handleSeeMore();
  }, []);

  const formatMatchTime = (matchTime) => {
    if (typeof matchTime !== "number" || matchTime < 0) {
      throw new Error("Input must be a valid non-negative number");
    }

    // Convert to milliseconds for JavaScript Date
    const date = new Date(matchTime * 1000);

    // Adjust to GMT+7
    const hours = date.getUTCHours() + 7; // Add 7 hours for GMT+7
    const minutes = date.getUTCMinutes();

    // Handle overflow for hours
    const adjustedHours = hours % 24;

    // Format to hh:mm
    return `${String(adjustedHours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
  };

  const calculateMatchTime = (halfStartTime) => {
    if (typeof halfStartTime !== "number" || halfStartTime <= 0) {
      return "00";
    }

    const now = Date.now(); // Current time in milliseconds
    const currentTimeInSeconds = Math.floor(now / 1000); // Convert to seconds

    const elapsedTime = currentTimeInSeconds - halfStartTime; // Calculate elapsed time in seconds

    const totalMinutes = Math.floor(elapsedTime / 60); // Convert to minutes

    // Ensure at least 2 digits
    return String(Math.max(totalMinutes, 0)).padStart(2, "0");
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api1");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `https://api-ls.cdnokvip.com/api/match-detail?matchId=${matchId}`,
        requestOptions
      );

      const data = await response.json();
      setDataLive(data?.value?.datas);
      scrollToTop();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const listDataLive = async () => {
    setIsLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api-ls.cdnokvip.com/api/get-livestream-group?current=${paging.current}&pageSize=${paging.pageSize}`,
        requestOptions
      );
      const data = await response.json();
      if (
        data?.value?.datas?.length === 0 ||
        data?.value?.datas?.length < paging.pageSize
      );
      setIsShowLoadMore(true);
      setListLive(data?.value?.datas);
      setIsLoading(false);
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSeeMore = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api2");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };
      const response = await fetch(
        `https://api-ls.cdnokvip.com/api/get-livestream?current=${
          paging.current + 1
        }&pageSize=${paging.pageSize}`,
        requestOptions
      );
      const data = await response.json();

      if (data?.value?.datas?.length) {
        setListLive([...listLive, ...data?.value?.datas]);
      }

      if (
        // data?.value?.datas?.length === 0 ||
        // data?.value?.datas?.length < paging.pageSize
        data?.value?.datas?.length === paging.pageSize
      ) {
        setIsShowLoadMore(true);
        const _paging = {
          current: paging.current + 1,
          pageSize: paging.pageSize,
        };
        setPaging(_paging);
      } else {
        setIsShowLoadMore(false);
      }
    } catch (error) {
      console.error("Error list live", error);
    } finally {
      setIsLoading(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const setupVideo = () => {
      if (videoRef.current && dataLive?.linkLive) {
        const videoSrc = dataLive.linkLive;
        try {
          if (dataLive.linkLive !== null) {
            if (Hls.isSupported()) {
              const hls = new Hls();
              console.log("HLS Supported:", hls);
              hls.loadSource(videoSrc);
              hls.attachMedia(videoRef.current);
            } else if (
              videoRef.current.canPlayType("application/vnd.apple.mpegurl")
            ) {
              console.log("HLS Not Supported - Using Alternative");
              videoRef.current.src = videoSrc;
            }
          } else {
            videoSrc =
              "https://customer-ey8v77zb1s9b8ygc.cloudflarestream.com/2483b1ae059a2caab3800cf1f8c87de1/manifest/video.m3u8";
            if (Hls.isSupported()) {
              const hls = new Hls();
              console.log("HLS Supported:", hls);
              hls.loadSource(videoSrc);
              hls.attachMedia(videoRef.current);
            } else if (
              videoRef.current.canPlayType("application/vnd.apple.mpegurl")
            ) {
              console.log("HLS Not Supported - Using Alternative");
              videoRef.current.src = videoSrc;
            }
          }
        } catch (error) {
          console.error("HLS error", error);
        }
      }
    };

    setupVideo();
  }, [dataLive]);

  useEffect(() => {
    const setupVideoQc = () => {
      const videoSrc =
        "https://customer-kr8gl4xkz7zjtk52.cloudflarestream.com/6576d4a600daa61bfcc0faa6551aff4f/manifest/video.m3u8";
      try {
        if (Hls.isSupported()) {
          const hls = new Hls();
          console.log("HLS Supported:", hls);
          hls.loadSource(videoSrc);
          hls.attachMedia(videoQc.current);
        } else if (
          videoQc.current.canPlayType("application/vnd.apple.mpegurl")
        ) {
          console.log("HLS Not Supported - Using Alternative");
          videoQc.current.src = videoSrc;
        }
      } catch (error) {
        console.error("HLS error", error);
      }
    };

    setupVideoQc();
  }, [dataLive]);

  const FormatNumber = ({ number }) => {
    const formattedNumber = (number / 1000).toString(); // Convert 130000 to 130
    return <span className="!tw-text-black">{formattedNumber}k</span>;
  };

  const formatCommentator = (name) => {
    // Loại bỏ các ký tự không cần thiết như dấu ngoặc
    const cleanedName = name.replace(/\(.*?\)/g, "").trim();

    // Split the name into parts
    const nameParts = cleanedName.split(" ");

    // Ignore the "BLV" prefix if it exists
    const filteredParts = nameParts.filter(
      (part) => part.toUpperCase() !== "BLV"
    );

    // Get the initials of the first name and the last name
    const initials = filteredParts[0][0].toUpperCase(); // First letter of the first name
    const lastName = filteredParts[filteredParts.length - 1].toUpperCase(); // Full last name

    return `${initials}.${lastName}`;
  };

  return (
    <div className="tw-flex !tw-bg-[#efefef] tw-h-full">
      <Sidebar />
      <div className="tw-w-full xl:tw-p-4">
        <div className="tw-flex tw-h-full tw-flex-col xl:tw-flex-row tw-gap-2">
          <div className="tw-flex tw-h-full tw-w-full xl:tw-w-[70%] tw-flex-col xl:tw-space-y-3">
            <div className="tw-relative">
              {dataLive?.linkLive ? (
                <>
                  <video
                    className="tw-rounded-none xl:tw-rounded-lg"
                    ref={videoRef}
                    autoPlay
                    controls
                    muted
                    width="100%"
                    height="100%"
                  />
                  <a
                    href={`/vao-phong-live/truc-tiep/${matchId}`}
                    rel="nofollow noopener"
                    target="_blank"
                    className="art-join-room"
                  >
                    Vào phòng live
                  </a>
                </>
              ) : (
                <div className="tw-w-full tw-video">
                  <video
                    className="xl:tw-rounded-lg"
                    ref={videoQc}
                    autoPlay
                    controls
                    muted
                    width="100%"
                    height="100%"
                  />
                </div>
              )}
            </div>
            <div className="tw-bg-[linear-gradient(90deg,_#FFDE29_0%,_#FFF17A_18.5%,_#FFDE29_38%,_#FFD852_58%,_#FFF17A_75.5%,_#FFDE29_88%,_#FE7_100%)] xl:tw-hidden">
              <div className="tw-flex tw-items-center tw-gap-1 tw-p-1">
                <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-truncate tw-rounded tw-border-[1px] bg-white p-1 hover:cursor-pointer hover:border-[#FFDE29]  xl:p-2">
                  <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 lg:tw-gap-2 xl:tw-justify-start">
                    <span className="tw-relative tw-flex tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-size-5 tw-ring-1 tw-ring-black lg:tw-size-9 xl:tw-size-12">
                      <img
                        className="tw-aspect-square tw-h-full tw-w-full tw-object-cover"
                        alt=""
                        src={
                          dataLive?.listCommentators?.find(
                            (item) =>
                              item.commentatorId === dataLive?.commentatorId
                          )?.avatar
                        }
                      />
                    </span>
                    <div className="tw-flex tw-flex-1 tw-flex-col">
                      <span className="tw-truncate tw-text-xs tw-font-semibold sm:tw-text-sm !tw-text-black">
                        {dataLive?.commentator &&
                          formatCommentator(dataLive?.commentator)}
                      </span>
                    </div>
                    <span className="tw-w-4 tw-rounded-sm tw-bg-red-600 tw-px-1 tw-py-0.5 xl:tw-w-auto">
                      <img
                        src="data:image/webp;base64,UklGRhACAABXRUJQVlA4WAoAAAASAAAAFwAAFwAAQU5JTQYAAAAAAAAAAABBTk1GPAAAAAAAAAAAABcAABcAADIAAAJWUDhMIwAAAC8XwAUQDzD/8z//8x/wUNC2DVNg5Y/sbggi+j8BsAyYvYQEAEFOTUY2AAAAAQAAAQAAEwAABwAAMgAAAlZQOEwdAAAALxPAARAPMP/zP//zH/AQkBAe+P9XNkT0fwJI8SQAQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/AoSTQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/Akg9QU5NRjQAAAABAAABAAATAAAHAAAyAAACVlA4TBsAAAAvE8ABEA8w//M///Mf8BAIJBnsLzxDRP9DpgUAQU5NRjYAAAABAAABAAATAAAHAAAyAAACVlA4TB0AAAAvE8ABEA8w//M///Mf8BCQEB74/1c2RPR/AmiPCQBBTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CaB1BTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CwNE="
                        alt=""
                        className="tw-h-3 tw-w-3 tw-object-contain"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="tw-w-full tw-mt-2 tw-hidden xl:tw-block">
              <div className="tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-md !tw-bg-white xl:tw-h-24">
                <div className="xl:tw-flex tw-w-full tw-space-x-2 tw-p-1.5 xl:tw-w-3/5 xl:tw-space-x-3 xl:tw-p-3">
                  <span className="tw-relative tw-flex tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-size-10 tw-ring-2 tw-ring-[#FFDE29] xl:tw-size-14 2xl:tw-size-16">
                    <img
                      className="tw-aspect-square tw-h-full tw-w-full tw-object-cover"
                      alt=""
                      src={
                        dataLive?.listCommentators?.find(
                          (item) =>
                            item.commentatorId === dataLive?.commentatorId
                        )?.avatar
                      }
                    />
                  </span>
                  <div className="tw-flex tw-flex-col tw-justify-between tw-space-y-1 tw-text-xs xl:tw-text-base">
                    <div className="tw-space-x-2 tw-whitespace-nowrap tw-font-semibold xl:tw-font-bold">
                      <span className="!tw-text-black">
                        {dataLive?.leagueShortName || dataLive?.leagueName}
                      </span>
                      <span className="!tw-text-black">
                        {dataLive.homeName}
                      </span>
                      <span className="tw-text-sm tw-text-[#FFDE29] xl:tw-text-xl">
                        {dataLive.homeScore} - {dataLive.awayScore}
                      </span>
                      <span className="!tw-text-black">
                        {dataLive.awayName}
                      </span>
                    </div>
                    <div className="tw-flex tw-items-center tw-space-x-2 tw-font-semibold xl:tw-font-bold">
                      <span className="tw-truncate !tw-text-black">
                        {dataLive?.commentator}
                      </span>
                      <span>
                        <div className="tw-flex tw-items-center tw-gap-0.5 tw-text-xs tw-font-medium xl:tw-text-sm">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="18"
                            viewBox="0 0 17 18"
                            fill="none"
                          >
                            <path
                              d="M8.94765 15.7305C11.0735 15.3048 13.8224 13.7753 13.8224 9.82069C13.8224 6.22246 11.1885 3.8259 9.29448 2.72487C8.87352 2.48005 8.38183 2.80172 8.38183 3.28797V4.53113C8.38183 5.51179 7.96971 7.30172 6.82448 8.0464C6.23962 8.42655 5.60716 7.85734 5.53643 7.16367L5.47795 6.59377C5.40994 5.93139 4.73531 5.52947 4.20622 5.93343C3.25481 6.6577 2.26123 7.92942 2.26123 9.82001C2.26123 14.656 5.8581 15.8658 7.6562 15.8658C7.76138 15.8658 7.8711 15.8624 7.98535 15.8556C7.09719 15.7801 5.66157 15.2293 5.66157 13.4475C5.66157 12.0534 6.67826 11.1115 7.45082 10.6524C7.65892 10.53 7.90171 10.6898 7.90171 10.9312V11.3325C7.90171 11.6385 8.02072 12.118 8.30295 12.4457C8.62258 12.8171 9.09114 12.4281 9.12855 11.9398C9.14079 11.7861 9.29584 11.6882 9.42914 11.7657C9.86506 12.0207 10.422 12.5648 10.422 13.4475C10.422 14.8403 9.65424 15.4809 8.94765 15.7305Z"
                              fill="#FFDE29"
                            ></path>
                          </svg>
                          {<FormatNumber number={dataLive?.viewNumber} />}
                        </div>
                      </span>
                      <button className="tw-gap-2 tw-whitespace-nowrap tw-transition-colors tw-focus-visible:tw-outline-none tw-focus-visible:tw-ring-1 tw-focus-visible:tw-ring-ring tw-disabled:tw-pointer-events-none tw-disabled:tw-opacity-50 [&_svg]:tw-pointer-events-none [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 tw-bg-primary tw-px-4 tw-py-2 tw-flex tw-h-6 tw-w-fit tw-items-center tw-justify-center tw-rounded-full tw-pl-1 tw-pr-2 tw-text-xs tw-font-semibold tw-text-black tw-shadow-none hover:tw-bg-[#fff129] xl:tw-h-7 xl:tw-text-sm tw-bg-[linear-gradient(90deg,_#FFDE29_0%,_#FFF17A_18.5%,_#FFDE29_38%,_#FFD852_58%,_#FFF17A_75.5%,_#FFDE29_88%,_#FE7_100%)]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-circle-plus"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <path d="M8 12h8"></path>
                          <path d="M12 8v8"></path>
                        </svg>
                        <span className="!tw-text-black">Theo dõi</span>
                        <span className="!tw-text-black"> - </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-circle-user"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <circle cx="12" cy="10" r="3"></circle>
                          <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>
                        </svg>
                        <span className="!tw-text-black">
                          {
                            dataLive?.listCommentators?.find(
                              (item) =>
                                item.commentatorId === dataLive?.commentatorId
                            )?.followBLV
                          }
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="tw-hidden tw-h-[100px] tw-skew-x-[-45deg] tw-rounded-tl-3xl tw-border-l-4 tw-border-[#FFDE29] tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] xl:tw-flex 2xl:tw-w-2/5">
                  <div className="tw-ml-auto tw-flex tw-h-full tw-w-[85%] tw-skew-x-[45deg] tw-items-center tw-justify-start tw-space-x-6 tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-px-4 2xl:tw-px-0 3xl:tw-w-[80%] 4xl:tw-justify-center">
                    <div className="tw-flex -tw-translate-x-10 tw-items-center tw-justify-center tw-gap-10">
                      <div className="tw-h-20">
                        <img
                          src="https://res.cloudinary.com/dhssqbwnq/image/upload/v1737526309/bhc5f0retuqeh7kcitdc.png"
                          alt="Logo OKVIP"
                          className="tw-h-full tw-w-full tw-object-contain"
                        />
                      </div>
                      <div className="tw-mx-0 tw-h-12 tw-translate-y-1 tw-rounded-md tw-bg-white tw-p-1 2xl:tw-h-14 2xl:tw-p-2">
                        <a
                          className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"
                          href="https://livels2.com/"
                          target="_blank"
                        >
                          <img
                            src="https://res.cloudinary.com/dhssqbwnq/image/upload/v1737525694/okfnkcvv6bnlpl0ysrjv.png"
                            alt="Logo OK9"
                            className="tw-h-full tw-w-full tw-object-contain"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <iframe
              src={`https://luongson.tv/embed-chat/${matchId}`}
              title="chat"
              className="tw-h-[350px] tw-w-full xl:tw-hidden tw-m-0"
              allow="autoplay"
              frameborder="0"
              marginheight="0"
            ></iframe>
            <div className="tw-container tw-mt-4 2xl:tw-mt-8">
              <div className="tw-flex tw-w-full tw-flex-col tw-space-y-4 xl:tw-space-y-8 3xl:tw-w-[calc(100%-150px)]">
                <div className="tw-w-full">
                  <div className="tw-mt-4 tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-grid-cols-2 lg:tw-gap-6 2xl:tw-grid-cols-3 4xl:tw-grid-cols-4">
                    {listLive?.map((item, index) => (
                      <div
                        className="tw-w-full tw-rounded tw-border-2 tw-border-[#C0C2C5]"
                        key={index}
                      >
                        <a
                          href={`#/live/${item.matchId}`}
                          className="tw-flex tw-flex-col tw-gap-3 tw-rounded-t-sm tw-p-3 !tw-text-black"
                        >
                          <div className="tw-flex tw-justify-between">
                            <span className="tw-truncate tw-text-sm tw-font-medium">
                              {item?.leagueShortName || item?.leagueName}
                            </span>
                            {item.status > 0 ? (
                              <div className="tw-flex tw-gap-2">
                                <div className="tw-flex tw-items-center tw-gap-0.5 tw-text-xs tw-font-medium xl:tw-text-sm">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                  >
                                    <path
                                      d="M8.94765 15.7305C11.0735 15.3048 13.8224 13.7753 13.8224 9.82069C13.8224 6.22246 11.1885 3.8259 9.29448 2.72487C8.87352 2.48005 8.38183 2.80172 8.38183 3.28797V4.53113C8.38183 5.51179 7.96971 7.30172 6.82448 8.0464C6.23962 8.42655 5.60716 7.85734 5.53643 7.16367L5.47795 6.59377C5.40994 5.93139 4.73531 5.52947 4.20622 5.93343C3.25481 6.6577 2.26123 7.92942 2.26123 9.82001C2.26123 14.656 5.8581 15.8658 7.6562 15.8658C7.76138 15.8658 7.8711 15.8624 7.98535 15.8556C7.09719 15.7801 5.66157 15.2293 5.66157 13.4475C5.66157 12.0534 6.67826 11.1115 7.45082 10.6524C7.65892 10.53 7.90171 10.6898 7.90171 10.9312V11.3325C7.90171 11.6385 8.02072 12.118 8.30295 12.4457C8.62258 12.8171 9.09114 12.4281 9.12855 11.9398C9.14079 11.7861 9.29584 11.6882 9.42914 11.7657C9.86506 12.0207 10.422 12.5648 10.422 13.4475C10.422 14.8403 9.65424 15.4809 8.94765 15.7305Z"
                                      fill="#FFDE29"
                                    ></path>
                                  </svg>
                                  <span>
                                    {<FormatNumber number={item.viewNumber} />}
                                  </span>
                                </div>
                                <span className="tw-flex tw-items-center tw-justify-center tw-gap-0.5 tw-rounded tw-bg-[#f00000] tw-px-1 tw-py-0.5 tw-text-xs tw-font-medium tw-text-white">
                                  <img
                                    src="data:image/webp;base64,UklGRhACAABXRUJQVlA4WAoAAAASAAAAFwAAFwAAQU5JTQYAAAAAAAAAAABBTk1GPAAAAAAAAAAAABcAABcAADIAAAJWUDhMIwAAAC8XwAUQDzD/8z//8x/wUNC2DVNg5Y/sbggi+j8BsAyYvYQEAEFOTUY2AAAAAQAAAQAAEwAABwAAMgAAAlZQOEwdAAAALxPAARAPMP/zP//zH/AQkBAe+P9XNkT0fwJI8SQAQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/AoSTQU5NRjQAAAABAAABAAATAAAFAAAyAAACVlA4TBwAAAAvE0ABEA8w//M///Mf8BCQEB74/1c2RPR/Akg9QU5NRjQAAAABAAABAAATAAAHAAAyAAACVlA4TBsAAAAvE8ABEA8w//M///Mf8BAIJBnsLzxDRP9DpgUAQU5NRjYAAAABAAABAAATAAAHAAAyAAACVlA4TB0AAAAvE8ABEA8w//M///Mf8BCQEB74/1c2RPR/AmiPCQBBTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CaB1BTk1GNAAAAAEAAAIAABMAAAUAADIAAAJWUDhMHAAAAC8TQAEQDzD/8z//8x/wEJAQHvj/VzZE9H8CwNE="
                                    alt=""
                                    className="tw-h-3 tw-w-2.5 tw-object-contain"
                                  />
                                  <span>Live</span>
                                </span>
                              </div>
                            ) : (
                              <div className="tw-flex tw-gap-2">
                                <span className="tw-text-sm tw-font-medium">
                                  {formatMatchTime(item.matchTime)}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                            <div className="tw-flex tw-w-2/5 tw-flex-col tw-items-center tw-justify-center">
                              <img
                                className="tw-size-12 tw-rounded-full tw-bg-white tw-object-contain"
                                src={item.homeLogo}
                                alt=""
                              />
                              <p className="tw-mt-1 tw-w-full tw-truncate tw-text-center tw-font-medium !tw-text-black">
                                {item.homeName}
                              </p>
                            </div>
                            {item.status > 0 ? (
                              <div className="tw-flex tw-w-1/5 tw-flex-col tw-items-center tw-justify-center">
                                <span className="tw-truncate tw-text-lg tw-font-semibold tw-text-[#00BE23]">
                                  {calculateMatchTime(item.halfStartTime)}
                                  <span className="tw-animate-blink tw-ml-[2px]">
                                    '
                                  </span>
                                </span>
                                <span className="tw-mx-auto tw-w-full tw-whitespace-nowrap tw-rounded tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-py-1 tw-text-center tw-text-xl tw-font-semibold tw-text-white xl:tw-w-[80%]">
                                  0:1
                                </span>
                              </div>
                            ) : (
                              <div className="tw-flex tw-w-1/5 tw-flex-col tw-items-center tw-justify-center">
                                <span className="tw-mx-auto tw-w-full tw-whitespace-nowrap tw-rounded tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-py-1 tw-text-center tw-text-xl tw-font-semibold tw-text-white xl:tw-w-[80%]">
                                  VS
                                </span>
                              </div>
                            )}

                            <div className="tw-flex tw-w-2/5 tw-flex-col tw-items-center tw-justify-center">
                              <img
                                className="tw-size-12 tw-rounded-full tw-bg-white tw-object-contain"
                                src={item.awayLogo}
                                alt=""
                              />
                              <p className="tw-mt-1 tw-w-full tw-truncate tw-text-center tw-font-medium !tw-text-black">
                                {item.awayName}
                              </p>
                            </div>
                          </div>
                        </a>

                        <div className="tw-rounded-b-sm tw-bg-gradient-to-b tw-from-[#ffffff] tw-to-[#FFFEED] tw-p-2">
                          <div className="tw-flex tw-w-full tw-items-center tw-gap-1">
                            <button className="!tw-inline-flex !tw-items-center !tw-justify-center !tw-gap-2 !tw-whitespace-nowrap !tw-rounded-md !tw-text-sm !tw-font-medium !tw-transition-colors !tw-focus-visible:tw-outline-none !tw-focus-visible:tw-ring-1 !tw-focus-visible:tw-ring-ring !tw-disabled:tw-pointer-events-none !tw-disabled:tw-opacity-50 [&_svg]:!tw-pointer-events-none [&_svg]:!tw-size-4 [&_svg]:!tw-shrink-0 !tw-border !tw-border-input !tw-bg-background !tw-shadow-sm hover:!tw-bg-accent hover:!tw-text-accent-foreground !tw-h-full !tw-w-7 !tw-p-3 swiper-blv-button-prev-349019520 !tw-text-black">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="lucide lucide-chevron-left"
                              >
                                <path d="m15 18-6-6 6-6"></path>
                              </svg>
                            </button>
                            <Swiper
                              slidesPerView={Math.min(
                                4,
                                item?.liveScoreRefs?.length
                              )}
                              spaceBetween={30}
                              className="mySwiper1"
                              autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                              }}
                            >
                              {item?.liveScoreRefs?.map(
                                (commentator, indexCom) => (
                                  <SwiperSlide key={indexCom}>
                                    <a
                                      className="tw-flex tw-flex-col tw-items-center tw-justify-center"
                                      href={`#/live/${commentator.matchId}`}
                                    >
                                      <span className="tw-relative tw-flex shrink-0 tw-overflow-hidden tw-rounded-full tw-h-7 tw-w-7 border border-white">
                                        <img
                                          className="tw-aspect-square tw-h-full tw-w-full tw-object-cover"
                                          alt=""
                                          src={commentator.avatar}
                                        />
                                      </span>
                                      <span className="tw-mt-0.5 tw-truncate tw-text-xs tw-font-semibold !tw-text-black">
                                        {formatCommentator(
                                          commentator.commentator
                                        )}
                                      </span>
                                    </a>
                                  </SwiperSlide>
                                )
                              )}
                            </Swiper>
                            <button className="!tw-inline-flex !tw-items-center !tw-justify-center !tw-gap-2 !tw-whitespace-nowrap !tw-rounded-md !tw-text-sm !tw-font-medium !tw-transition-colors !tw-focus-visible:tw-outline-none !tw-focus-visible:tw-ring-1 !tw-focus-visible:tw-ring-ring !tw-disabled:tw-pointer-events-none !tw-disabled:tw-opacity-50 [&_svg]:!tw-pointer-events-none [&_svg]:!tw-size-4 [&_svg]:!tw-shrink-0 !tw-border !tw-border-input !tw-bg-background !tw-shadow-sm hover:!tw-bg-accent hover:!tw-text-accent-foreground !tw-h-full !tw-w-7 !tw-p-3 swiper-blv-button-next-349019520 !tw-text-black">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="lucide lucide-chevron-right"
                              >
                                <path d="m9 18 6-6-6-6"></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-hidden xl:tw-flex tw-h-full tw-w-full xl:tw-w-[30%] tw-flex-col tw-justify-between tw-rounded tw-border tw-border-[#FFDE29] xl:tw-h-[678px] 3xl:tw-h-[748px] 4xl:tw-h-[1008px]">
            <ChatComponent matchId={matchId} />
          </div>
        </div>
      </div>
    </div>
  );
}
